import { render } from "./SignInBody.vue?vue&type=template&id=f04adae6&scoped=true"
import script from "./SignInBody.vue?vue&type=script&lang=js"
export * from "./SignInBody.vue?vue&type=script&lang=js"

import "./SignInBody.vue?vue&type=style&index=0&id=f04adae6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f04adae6"]])

export default __exports__